/**
 * Component: Cart add-on script
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for the Cart add-on functionality.
 *
 * @namespace sizeChart
 */
 
 import cssClasses from '~/helpers/cssClasses';
 import {debounce, on} from '~/helpers/utils';
 import Modal from '~/components/modal';
 
 /**
  * DOM selectors.
  */
 const selectors = {
   panel: '[js-pdp="panel"]',
   container: '[js-size-chart="container"]',
   popupTrigger: '[js-size-chart="trigger"]',
   modal: '[js-size-chart="modal"]',
   modalClose: '[js-size-chart="closeModal"]',
   modalCard: '[js-size-chart="modalCard"]',
   descShow: '[js-size-chart="descShow"]',
 };
 
 
 /**
  * Instance settings.
  */
 const settings = {
   id: 'size-chart-modal',
 };

 /**
  * Create a new cart add-on object.
  */
 export default () => {
 
   /**
    * DOM node selectors.
    */
   const nodeSelectors = {
     panel: document.querySelector(selectors.panel),
     modal: document.querySelector(selectors.modal),
     modalClose: document.querySelector(selectors.modalClose),
     modalCard: document.querySelector(selectors.modalCard),
   };
   /**
    * DOM add-on selectors.
    */
   const addOnSelectors = {
     container: nodeSelectors.panel.querySelector(selectors.container),
     popupTrigger: nodeSelectors.panel.querySelector(selectors.popupTrigger),
     descShow: nodeSelectors.panel.querySelector(selectors.descShow),
   };
 
   /**
    * Instance globals.
    */
   const modal = Modal({
     id: settings.id,
   });
 
   /**
    * Initialise component.
    */
   function init() {
     if (!nodeSelectors.panel) {
       return;
     }
 
     modal.init();
     setEventBusListeners();
     setEventListeners();
   }
 
   /**
    * Set eventBus listeners.
    */
   function setEventBusListeners() {
     Frame.EventBus.listen('CartTable:rendered', (response) => setInitState(response));
     Frame.EventBus.listen(`Modal:Show:${settings.id}`, () => onModalShowCallback());
   }
 
   /**
    * Set event listeners.
    */
   function setEventListeners() {
     on('click', addOnSelectors.descShow, (event) => addOnDescShow(event));
     on('click', nodeSelectors.modalClose, () => handleModalCloseEvent());
    }

 
   /**
    * Show add-on description.
    * @param {Event} event - click event.
    */
   function addOnDescShow(event) {
     event.preventDefault();
 
     handleModalShowEvent();
   }
 
  
 
   /**
    * Handle modal show.
    */
   function handleModalShowEvent() {
     modal.show(settings.id);
   }
 
   /**
    * Handle modal close.
    */
   function handleModalCloseEvent() {
     modal.close(settings.id);
   }
 
     function onModalShowCallback() {
    on('click', nodeSelectors.modal, (event) => {

      window.setTimeout(() => {
        if (nodeSelectors.modalCard.contains(event.target)) { return; }
        handleModalCloseEvent();
      }, 300);
    });
  }
 
   /**
    * Expose public interface.
    */
   return Object.freeze({
     init,
   });
 };
 